import { render, staticRenderFns } from "./ReportPendingAwards.vue?vue&type=template&id=3809d223"
import script from "./ReportPendingAwards.vue?vue&type=script&lang=js"
export * from "./ReportPendingAwards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports